import React, { useState } from "react";
import "./FilterPP.css"; // CSS file for styling

const FilterPP = ({ applyFilters, onClose }) => {
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [minArea, setMinArea] = useState("");
  const [maxArea, setMaxArea] = useState("");
  const [bedrooms, setBedrooms] = useState("");
  const [bathrooms, setBathrooms] = useState("");
  const [orientation, setOrientation] = useState("");
  const [furniture, setFurniture] = useState("");
  const [heatingSystem, setHeatingSystem] = useState("");
  const [additionalFeatures, setAdditionalFeatures] = useState([]);
  const [hasOwnershipDocument, setHasOwnershipDocument] = useState("");
  const [floorLevel, setFloorLevel] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [neighborhood, setNeighborhood] = useState("");
  const [builder, setBuilder] = useState("");
  const [complex, setComplex] = useState("");

  // Handle checkbox for additional features
  const handleAdditionalFeaturesChange = (e) => {
    const { name, checked } = e.target;
    if (checked) {
      setAdditionalFeatures([...additionalFeatures, name]);
    } else {
      setAdditionalFeatures(
        additionalFeatures.filter((feature) => feature !== name)
      );
    }
  };

  // Handle the application of filters
  const applyFilter = () => {
    applyFilters({
      minPrice,
      maxPrice,
      propertyType,
      minArea,
      maxArea,
      bedrooms,
      bathrooms,
      orientation,
      furniture,
      heatingSystem,
      additionalFeatures,
      hasOwnershipDocument,
      floorLevel,
      country,
      city,
      neighborhood,
      builder,
      complex,
    });
    onClose(); // Close the filter after applying
  };
  const clearFilters = () => {
    setMinPrice("");
    setMaxPrice("");
    setPropertyType("");
    setMinArea("");
    setMaxArea("");
    setBedrooms("");
    setBathrooms("");
    setOrientation("");
    setFurniture("");
    setHeatingSystem("");
    setAdditionalFeatures([]);
    setHasOwnershipDocument("");
    setFloorLevel("");
    setCountry("");
    setCity("");
    setNeighborhood("");
    setBuilder("");
    setComplex("");

    // Apply empty filters to reset the property list
    applyFilters({
      minPrice: "",
      maxPrice: "",
      propertyType: "",
      minArea: "",
      maxArea: "",
      bedrooms: "",
      bathrooms: "",
      orientation: "",
      furniture: "",
      heatingSystem: "",
      additionalFeatures: [],
      hasOwnershipDocument: "",
      floorLevel: "",
      country: "",
      city: "",
      neighborhood: "",
      builder: "",
      complex: "",
    });

    onClose(); // Close the filter modal after clearing
  };

  return (
    <div className="filter-container">
      <h2>Filter Properties</h2>

      {/* Property Type */}
      <div className="filter-group">
        <label>Lloji i Patundshmërisë:</label>
        <select
          name="propertyType"
          value={propertyType}
          onChange={(e) => setPropertyType(e.target.value)}
        >
          <option value="">All</option>
          <option value="Apartment">Banesë</option>
          <option value="House">Shtepi</option>
          <option value="Office">Zyre</option>
          <option value="Store">Lokal</option>
          <option value="Land">Troje</option>
          <option value="Land">Depo</option>
          <option value="Land">Objekte</option>
        </select>
      </div>

      {/* Price Range */}
      <div className="filter-group-price">
        <label>Çmimi:</label>
        <div className="filter-group-price-input">
          <input
            type="number"
            name="minPrice"
            placeholder="Min Price"
            value={minPrice}
            onChange={(e) => setMinPrice(e.target.value)}
          />
          <span> - </span>
          <input
            type="number"
            name="maxPrice"
            placeholder="Max Price"
            value={maxPrice}
            onChange={(e) => setMaxPrice(e.target.value)}
          />
        </div>
      </div>

      {/* Area Range */}
      <div className="filter-group">
        <label>Sipërfaqja</label>
        <div className="filter-group-input">
          <input
            type="number"
            name="minArea"
            placeholder="Min Area"
            value={minArea}
            onChange={(e) => setMinArea(e.target.value)}
          />
          <span> - </span>
          <input
            type="number"
            name="maxArea"
            placeholder="Max Area"
            value={maxArea}
            onChange={(e) => setMaxArea(e.target.value)}
          />
        </div>
      </div>

      {/* Bedrooms */}
      <div className="filter-group">
        <label>Dhoma Gjumi:</label>
        <select
          name="bedrooms"
          value={bedrooms}
          onChange={(e) => setBedrooms(e.target.value)}
        >
          <option value="">Select Bedrooms</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
        </select>
      </div>

      {/* Bathrooms */}
      <div className="filter-group">
        <label>Banjo:</label>
        <select
          name="bathrooms"
          value={bathrooms}
          onChange={(e) => setBathrooms(e.target.value)}
        >
          <option value="">Select Bathrooms</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
        </select>
      </div>

      {/* Orientation */}
      <div className="filter-group">
        <label>Orientimi:</label>
        <select
          name="orientation"
          value={orientation}
          onChange={(e) => setOrientation(e.target.value)}
        >
          <option value="">Select Orientation</option>
          <option value="East">Lindje</option>
          <option value="West">Perëndim</option>
          <option value="North">Veri</option>
          <option value="South">Jug</option>
        </select>
      </div>

      {/* Heating System */}
      <div className="filter-group">
        <label>Heating System:</label>
        <select
          name="heatingSystem"
          value={heatingSystem}
          onChange={(e) => setHeatingSystem(e.target.value)}
        >
          <option value="">Select Heating System</option>
          <option value="Keds">Keds</option>
          <option value="Gas">Gas</option>
          <option value="Pelet">Pelet</option>
          <option value="Valiant">Valiant</option>
        </select>
      </div>

      {/* Ownership Document */}
      <div className="filter-group">
        <label>Letër Poseduese:</label>
        <select
          name="hasOwnershipDocument"
          value={hasOwnershipDocument}
          onChange={(e) => setHasOwnershipDocument(e.target.value)}
        >
          <option value="">Select Ownership Document</option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </div>

      {/* Floor Level */}
      <div className="filter-group">
        <label>Kati :</label>
        <select
          name="floorLevel"
          value={floorLevel}
          onChange={(e) => setFloorLevel(e.target.value)}
        >
          <option value="">Select Floor Level</option>
          <option value="Low">Low</option>
          <option value="Middle">Middle</option>
          <option value="High">High</option>
        </select>
      </div>

      {/* Location */}
      <div className="filter-group">
        <label>Shteti:</label>
        <select
          name="country"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
        >
          <option value="">Select Country</option>
          <option value="Kosovo">Kosovo</option>
          <option value="Albania">Albania</option>
        </select>
      </div>
      <div className="filter-group">
        <label>Qyteti:</label>
        <select
          name="city"
          value={city}
          onChange={(e) => setCity(e.target.value)}
        >
          <option value="">Select City</option>

          <optgroup label="Kosovo">
            <option value="Prishtina">Prishtina</option>
            <option value="Mitrovica">Mitrovica</option>
            <option value="Peja">Peja</option>
            <option value="Gjakova">Gjakova</option>
            <option value="Prizren">Prizren</option>
            <option value="Ferizaj">Ferizaj</option>
            <option value="Gjilan">Gjilan</option>
            <option value="Podujeva">Podujeva</option>
            <option value="Drenas">Drenas</option>
            <option value="Vushtrri">Vushtrri</option>
          </optgroup>

          <optgroup label="Albania">
            <option value="Tirana">Tirana</option>
            <option value="Durres">Durres</option>
            <option value="Vlore">Vlore</option>
            <option value="Shkoder">Shkoder</option>
            <option value="Fier">Fier</option>
            <option value="Berat">Berat</option>
            <option value="Elbasan">Elbasan</option>
            <option value="Gjirokaster">Gjirokaster</option>
            <option value="Korça">Korça</option>
            <option value="Lezhe">Lezhe</option>
          </optgroup>
        </select>
      </div>

      <div className="filter-apply-cancel">
        <button onClick={clearFilters} className="clear-filter">
          {" "}
          Clear Filters
        </button>
        <button onClick={applyFilter} className="apply-button">
          Apply Filters
        </button>
      </div>
    </div>
  );
};

export default FilterPP;
